import React from "react";
import { RegCredentials, registration } from "../ApiService";
import RegModule from "../modules/RegModule/RegModule";
import { useNavigate } from "react-router-dom";

const RegPage: React.FC = () => {
  const navigate = useNavigate();

  const credentials: RegCredentials = {
    email: "",
    password: "",
    name: "",
    secret: "",
  };

  const registerSubmit = (credentials: RegCredentials) => {
    registration(credentials)
      .then((userData) => {
        if ("email" in userData) {
          navigate("/login");
        }
      })
      .catch((error) => {
        console.error("Ошибка регистрации:", error);
      });
  };

  return (
    <div className="flex items-center justify-center h-screen bg-gray-200">
      <RegModule
        title="Регистрация"
        credentials={credentials}
        onSubmit={registerSubmit}
      />
    </div>
  );
};
export default RegPage;
